import { useState, useEffect, useCallback } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import logoDN from "./logo-dn.png";
import { apiBaseUrl, apiRequest, apiScope, loginRequest, msalConfig } from "./authConfig";
import PoliciesPage from "./pages/PoliciesPage";

function App() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const usuarioActual = accounts[0]?.username?.toLowerCase() || "";
  const nombreUsuario = accounts[0]?.name || usuarioActual;
  const rolesUsuario = accounts[0]?.idTokenClaims?.roles || [];
  const tieneAccesoAsignado = rolesUsuario.includes("User") || rolesUsuario.includes("Administrador");
  const puedeCrearTickets = rolesUsuario.includes("Administrador");

  const apiFetch = useCallback(async (path, options = {}) => {
    const headers = new Headers(options.headers || {});
    if (apiScope) {
      const account = accounts[0];
      if (!account) throw new Error("Sesión no disponible.");
      const tokenResponse = await instance.acquireTokenSilent({ ...apiRequest, account });
      headers.set("Authorization", `Bearer ${tokenResponse.accessToken}`);
    }
    return fetch(`${apiBaseUrl}${path}`, { ...options, headers });
  }, [accounts, instance]);

  const iniciarSesion = () => {
    sessionStorage.setItem("vistaActiva", "dashboard");
    const solicitudLogin = {
      ...loginRequest,
      ...(usuarioLogin.trim() ? { loginHint: usuarioLogin.trim() } : {}),
      prompt: "login"
    };

    instance.loginRedirect(solicitudLogin).catch((error) => {
      console.error("No fue posible iniciar sesión con Entra ID", error);
      setErrorAutenticacion(error.message || "No fue posible iniciar sesión.");
    });
  };

  const cerrarSesion = useCallback(() => {
    sessionStorage.removeItem("vistaActiva");
    instance.logoutRedirect({
      postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri
    }).catch((error) => {
      console.error("No fue posible cerrar sesión", error);
    });
  }, [instance]);

  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtroSeleccionado, setFiltroSeleccionado] = useState("");
  const [filtrosAplicados, setFiltrosAplicados] = useState({});
  const [devices, setDevices] = useState([]);
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [mostrarDuplicidad, setMostrarDuplicidad] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [mostrarMenuTickets, setMostrarMenuTickets] = useState(false);
  const [tipoTicket, setTipoTicket] = useState("");
  const [mostrarVistaTicket, setMostrarVistaTicket] = useState(false);
  const [enviandoTicket, setEnviandoTicket] = useState(false);
  const [mensajeTicket, setMensajeTicket] = useState("");
  const [ccTicket, setCcTicket] = useState("");
  const [errorAutenticacion, setErrorAutenticacion] = useState("");
  const [menuUsuarioAbierto, setMenuUsuarioAbierto] = useState(false);
  const [menuDashboardsAbierto, setMenuDashboardsAbierto] = useState(false);
  const [fotoUsuario, setFotoUsuario] = useState("");
  const [usuarioLogin, setUsuarioLogin] = useState("");
  const [mostrarPoliticas, setMostrarPoliticas] = useState(() => sessionStorage.getItem("vistaActiva") === "politicas");
  const versionesWindows = [
    "Windows 10",
    "Windows 11"
  ];

  const obtenerVersionWindows = (version = "") => {
    const build = String(version).match(/^10\.0\.(\d+)\./)?.[1];
    if (["10240", "10586", "14393", "15063", "16299", "17134", "17763", "18362", "18363", "19041", "19042", "19043", "19044", "19045"].includes(build)) return "Windows 10";
    if (
      ["22000", "22621", "22631", "26100", "26200", "26300", "28000"].includes(build)
    ) return "Windows 11";
    return version === "0.0.0.0" || !version ? "Sin versión reportada" : "Versión no identificada";
  };

  const obtenerDepartamento = (device) => {
    const departamento = device.deviceCategoryDisplayName
      ?.replace("Departamentos_", "")
      .trim();

    return departamento || "Unknown";
  };

  const obtenerOwnership = (device) => {
    const ownership = String(device.managedDeviceOwnerType || device.ownerType || "").toLowerCase();
    if (ownership === "company") return "Company";
    if (ownership === "personal") return "Personal";
    return ownership || "Unknown";
  };

  const departamentos = devices.reduce((acc, device) => {
  const categoria = obtenerDepartamento(device);

  acc[categoria] = (acc[categoria] || 0) + 1;
  return acc;
}, {});

  const aplicarFiltro = (tipo, valor) => {
  setFiltroSeleccionado(tipo);
  setFiltrosAplicados((filtros) => ({ ...filtros, [tipo]: valor }));
  setMostrarFiltros(false);
};

  const limpiarFiltro = (tipo) => {
    setFiltrosAplicados((filtros) => {
      const nuevosFiltros = { ...filtros };
      delete nuevosFiltros[tipo];
      return nuevosFiltros;
    });
    if (filtroSeleccionado === tipo) {
      setFiltroSeleccionado("");
    }
  };

  const generarCSV = () => {
    const columnas = ["Usuario", "Correo", "Equipo", "Departamento", "OS", "Compliance", "Ownership", "Versión", "Cifrado", "Join type"];
    const filas = devicesFiltrados.map((device) => [
      device.userDisplayName || "",
      device.userPrincipalName || "",
      device.deviceName || "",
      obtenerDepartamento(device),
      device.operatingSystem || "",
      device.complianceState || "",
      obtenerOwnership(device),
      obtenerVersionWindows(device.osVersion),
      device.isEncrypted ? "Sí" : "No",
      device.isJointype || ""
    ]);
    const escapar = (valor) => `"${String(valor).replace(/"/g, '""')}"`;
    const contenido = [columnas, ...filas].map((fila) => fila.map(escapar).join(",")).join("\r\n");
    const enlace = document.createElement("a");
    enlace.href = URL.createObjectURL(new Blob(["\uFEFF" + contenido], { type: "text/csv;charset=utf-8;" }));
    enlace.download = "dispositivos_intune.csv";
    enlace.click();
    URL.revokeObjectURL(enlace.href);
  };
useEffect(() => {
  if (!isAuthenticated) return undefined;
  let cancelled = false;

  apiFetch("/api/devices")
    .then(async (res) => {
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "No fue posible cargar los dispositivos.");
      return data;
    })
    .then((data) => {
      if (!cancelled) setDevices(data.value || []);
    })
    .catch((error) => {
      if (!cancelled) console.error("No fue posible cargar dispositivos", error.message);
    });

  return () => { cancelled = true; };
}, [apiFetch, isAuthenticated]);

  useEffect(() => {
    let urlFoto;

    const cargarFotoUsuario = async () => {
      if (!isAuthenticated || !accounts[0]) return;

      try {
        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        const respuesta = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: { Authorization: `Bearer ${tokenResponse.accessToken}` }
        });

        if (respuesta.ok) {
          const blob = await respuesta.blob();
          urlFoto = URL.createObjectURL(blob);
          setFotoUsuario(urlFoto);
        }
      } catch (error) {
        console.warn("No fue posible cargar la foto de perfil de Microsoft", error);
      }
    };

    cargarFotoUsuario();
    return () => {
      if (urlFoto) URL.revokeObjectURL(urlFoto);
    };
  }, [instance, isAuthenticated, accounts]);

  useEffect(() => {
    sessionStorage.setItem("vistaActiva", mostrarPoliticas ? "politicas" : "dashboard");
  }, [mostrarPoliticas]);

  useEffect(() => {
    if (!isAuthenticated) return undefined;

    let temporizador;
    const registrarActividad = () => {
      window.clearTimeout(temporizador);
      temporizador = window.setTimeout(() => {
        cerrarSesion();
      }, 5 * 60 * 1000);
    };
    const eventos = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];
    eventos.forEach((evento) => window.addEventListener(evento, registrarActividad, { passive: true }));
    registrarActividad();

    return () => {
      window.clearTimeout(temporizador);
      eventos.forEach((evento) => window.removeEventListener(evento, registrarActividad));
    };
  }, [isAuthenticated, cerrarSesion]);

  useEffect(() => {
    setPaginaActual(1);
  }, [textoBusqueda, mostrarDuplicidad, filtrosAplicados]);

  if (!isAuthenticated) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Segoe UI", backgroundImage: "linear-gradient(rgba(3, 16, 31, 0.68), rgba(6, 21, 47, 0.78)), url('https://wallpapers.com/images/hd/cybersecurity-background-oab75v94oynalo3j.jpg')", backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "relative", width: "min(430px, calc(100% - 40px))", padding: "38px", borderRadius: "18px", backgroundColor: "rgba(255,255,255,0.97)", boxShadow: "0 20px 60px rgba(0,0,0,0.4)", textAlign: "center" }}>
          <img src="https://adlswallpapers.blob.core.windows.net/wallpapers/dnlogo18-estandar-azul.png" alt="Logo Dichter" style={{ width: "min(340px, 92%)", height: "auto", maxHeight: "125px", objectFit: "contain", marginBottom: "18px" }} />
          <h1 style={{ color: "#0D5CAB", margin: "0 0 8px" }}>Portal de Intune</h1>
          <p style={{ color: "#536273", marginBottom: "25px" }}>Acceso seguro con tu cuenta corporativa</p>
          <label htmlFor="usuario-login" style={{ display: "block", textAlign: "left", color: "#26384a", fontWeight: "600", marginBottom: "7px" }}>Ingrese su usuario corporativo</label>
          <input id="usuario-login" type="email" value={usuarioLogin} onChange={(event) => setUsuarioLogin(event.target.value)} placeholder="usuario@dichter-neira.com" onKeyDown={(event) => { if (event.key === "Enter") iniciarSesion(); }} style={{ width: "100%", boxSizing: "border-box", padding: "13px", border: "1px solid #c7d2df", borderRadius: "8px", marginBottom: "15px", fontSize: "14px" }} />
          {errorAutenticacion && <p style={{ color: "#B00020", fontSize: "13px" }}>{errorAutenticacion}</p>}
          <button onClick={iniciarSesion} style={{ width: "100%", backgroundColor: "#0D5CAB", color: "white", border: "none", padding: "13px 22px", borderRadius: "8px", cursor: "pointer", fontWeight: "600", fontSize: "15px", marginTop: "8px" }}>
            Login
          </button>
        </div>
      </div>
    );
  }

  if (!tieneAccesoAsignado) {
    return (
      <div style={{ padding: "50px", textAlign: "center", fontFamily: "Segoe UI" }}>
        <h1>Acceso no autorizado</h1>
        <p>Tu usuario autenticado no está habilitado para este portal.</p>
        <button onClick={cerrarSesion}>Cerrar sesión</button>
      </div>
    );
  }

  if (mostrarPoliticas) {
    return <PoliciesPage onBack={() => setMostrarPoliticas(false)} canCreateTickets={puedeCrearTickets} apiFetch={apiFetch} />;
  }

const conteoEquiposPorUsuario = devices.reduce((acc, device) => {
  const usuario = device.userPrincipalName || device.userDisplayName;
  if (usuario) {
    acc[usuario] = (acc[usuario] || 0) + 1;
  }
  return acc;
}, {});

const usuariosConDuplicidad = new Set(
  Object.entries(conteoEquiposPorUsuario)
    .filter(([, cantidad]) => cantidad > 1)
    .map(([usuario]) => usuario)
);

const devicesFiltrados = devices.filter((device) => {

  const usuario = device.userPrincipalName || device.userDisplayName;
  const coincideDuplicidad = !mostrarDuplicidad || usuariosConDuplicidad.has(usuario);

  const coincideBusqueda =
    !textoBusqueda ||
    device.userDisplayName
      ?.toLowerCase()
      .includes(textoBusqueda.toLowerCase()) ||

    device.userPrincipalName
      ?.toLowerCase()
      .includes(textoBusqueda.toLowerCase()) ||

    device.deviceName
      ?.toLowerCase()
      .includes(textoBusqueda.toLowerCase());

  if (!coincideBusqueda || !coincideDuplicidad) {
    return false;
  }

  const coincideCompliance = !filtrosAplicados.Compliance ||
    device.complianceState?.toLowerCase() === filtrosAplicados.Compliance.toLowerCase();
  const coincideOS = !filtrosAplicados.OS ||
    device.operatingSystem?.toLowerCase() === filtrosAplicados.OS.toLowerCase();
  const coincideVersion = !filtrosAplicados.Version ||
    obtenerVersionWindows(device.osVersion) === filtrosAplicados.Version;
  const coincideDepartamento = !filtrosAplicados.Category ||
    obtenerDepartamento(device) === filtrosAplicados.Category;
  const coincideCifrado = !filtrosAplicados.Encrypted ||
    (filtrosAplicados.Encrypted === "Yes"
      ? device.isEncrypted === true
      : device.isEncrypted === false);

  return coincideCompliance && coincideOS && coincideVersion && coincideDepartamento && coincideCifrado;
}).sort((a, b) => {
  const usuarioA = (a.userDisplayName || a.userPrincipalName || "").trim();
  const usuarioB = (b.userDisplayName || b.userPrincipalName || "").trim();
  const usuarioOrden = usuarioA.localeCompare(usuarioB, "es", { sensitivity: "base" });

  if (usuarioOrden !== 0) return usuarioOrden;

  return (a.deviceName || "").localeCompare(b.deviceName || "", "es", {
    sensitivity: "base",
    numeric: true
  });
});

const departamentosFiltrados = devicesFiltrados.reduce((acc, device) => {
  const categoria = obtenerDepartamento(device);
  acc[categoria] = (acc[categoria] || 0) + 1;
  return acc;
}, {});

const registrosPorPagina = 50;
const totalPaginas = Math.max(1, Math.ceil(devicesFiltrados.length / registrosPorPagina));
const indiceInicial = (paginaActual - 1) * registrosPorPagina;
const devicesPagina = devicesFiltrados.slice(indiceInicial, indiceInicial + registrosPorPagina);

  const opcionesTicket = [
    { key: "duplicados", label: "Equipos duplicados" },
    { key: "noncompliant", label: "Equipos noncompliant" },
    { key: "windows10", label: "Windows 10" },
    { key: "sinPais", label: "Sin país" }
  ];

  const obtenerEquiposTicket = (tipo) => {
    if (tipo === "duplicados") {
      return devices.filter((device) => {
        const usuario = device.userPrincipalName || device.userDisplayName;
        return usuariosConDuplicidad.has(usuario);
      });
    }

    if (tipo === "noncompliant") {
      return devices.filter(
        (device) => device.complianceState?.toLowerCase() === "noncompliant"
      );
    }

    if (tipo === "windows10") {
      return devices.filter(
        (device) => obtenerVersionWindows(device.osVersion) === "Windows 10"
      );
    }

    if (tipo === "sinPais") {
      return devices.filter((device) => obtenerDepartamento(device) === "Unknown");
    }

    return [];
  };

  const escaparHtml = (valor) => String(valor || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  const prepararTicket = (tipo) => {
    setTipoTicket(tipo);
    setMostrarMenuTickets(false);
    setMensajeTicket("");
    setCcTicket("");
    setMostrarVistaTicket(true);
  };

  const enviarTicket = async () => {
    const opcion = opcionesTicket.find((item) => item.key === tipoTicket);
    const equipos = obtenerEquiposTicket(tipoTicket);

    if (!opcion || equipos.length === 0) {
      setMensajeTicket("No hay equipos para la inconsistencia seleccionada.");
      return;
    }

    const ccDirecciones = ccTicket.split(";").map((correo) => correo.trim()).filter(Boolean);
    const correosInvalidos = ccDirecciones.filter((correo) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo));
    if (correosInvalidos.length > 0) {
      setMensajeTicket(`Correo(s) CC inválido(s): ${correosInvalidos.join(", ")}. Usa direcciones separadas por ;`);
      return;
    }

    const escaparCsv = (valor) => `"${String(valor ?? "").replace(/"/g, '""')}"`;
    const csv = [
      ["Usuario", "Correo", "Equipo", "País", "OS", "Compliance", "Ownership"],
      ...equipos.map((device) => [
        device.userDisplayName || "-",
        device.userPrincipalName || "-",
        device.deviceName || "-",
        obtenerDepartamento(device),
        device.operatingSystem || "-",
        device.complianceState || "-",
        obtenerOwnership(device)
      ])
    ].map((fila) => fila.map(escaparCsv).join(",")).join("\r\n");
    const contenidoCsv = btoa(unescape(encodeURIComponent("\uFEFF" + csv)));
    const htmlBody = `<p>Hemos detectado que la inconsistencia <strong>${escaparHtml(opcion.label)}</strong> tiene <strong>${equipos.length}</strong> equipos. El detalle se encuentra en el archivo CSV adjunto.</p>`;

    setEnviandoTicket(true);
    setMensajeTicket("");

    try {
      const response = await apiFetch("/api/tickets", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subject: `Inconsistencia Intune: ${opcion.label} (${equipos.length} equipos)`,
          htmlBody,
          attachment: { name: `dispositivos_${tipoTicket}.csv`, contentType: "text/csv", contentBytes: contenidoCsv },
          cc: ccDirecciones.join(";")
        })
      });

      const responseText = await response.text();
      let data;

      try {
        data = JSON.parse(responseText);
      } catch {
        data = { error: responseText || `Respuesta HTTP ${response.status}` };
      }

      if (!response.ok) {
        const detail = typeof data.error === "string"
          ? data.error
          : JSON.stringify(data.error || data);
        throw new Error(detail || `Respuesta HTTP ${response.status}`);
      }

      setMostrarVistaTicket(false);
      setMensajeTicket("");
      window.alert("Ticket enviado correctamente a soportetecnico@dichter-neira.com.");
    } catch (error) {
      setMensajeTicket(`Error al enviar el ticket: ${error.message}`);
    } finally {
      setEnviandoTicket(false);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#F4F6F9",
        minHeight: "100vh",
        padding: "30px",
        fontFamily: "Segoe UI"
      }}
    >
      {/* HEADER */}
      <div
        style={{
          backgroundColor: "#0D5CAB",
          borderRadius: "15px",
          padding: "25px",
          marginBottom: "25px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            minHeight: "82px"
          }}
        >
          <img src={logoDN} alt="Logo Dichter-Neira" style={{ position: "absolute", left: 0, height: "78px", width: "auto", objectFit: "contain" }} />

          <h1
            style={{
              margin: 0,
              color: "white",
              textAlign: "center",
              fontSize: "clamp(22px, 3vw, 34px)"
            }}
          >
            PORTAL INTUNE INFORMATION
          </h1>

          <div style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}>
            <button
              onClick={() => setMenuUsuarioAbierto((abierto) => !abierto)}
              style={{ display: "flex", alignItems: "center", gap: "10px", background: "none", border: "none", color: "white", cursor: "pointer", fontWeight: "600", fontSize: "14px" }}
            >
              {fotoUsuario ? (
                <img src={fotoUsuario} alt="Foto del usuario" style={{ width: "38px", height: "38px", borderRadius: "50%", objectFit: "cover" }} />
              ) : (
                <span style={{ width: "38px", height: "38px", borderRadius: "50%", backgroundColor: "white", color: "#0D5CAB", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "15px" }}>
                  {nombreUsuario.split(" ").map((parte) => parte[0]).join("").slice(0, 2).toUpperCase()}
                </span>
              )}
              <span>{nombreUsuario}</span>
              <span>▾</span>
            </button>

            {menuUsuarioAbierto && (
              <div style={{ position: "absolute", right: 0, top: "calc(100% + 8px)", minWidth: "150px", backgroundColor: "white", borderRadius: "8px", boxShadow: "0 4px 14px rgba(0,0,0,0.2)", zIndex: 1500, padding: "6px" }}>
                <button onClick={() => { setMostrarPoliticas(true); setMenuUsuarioAbierto(false); }} style={{ ...opcionFiltro, color: "#333" }}>Políticas</button>
                <button onClick={() => setMenuDashboardsAbierto((abierto) => !abierto)} style={{ ...opcionFiltro, color: "#333" }}>Dashboards ▾</button>
                {menuDashboardsAbierto && <div style={{ padding: "4px 8px 6px" }}>
                  <a href="https://infra.dn-online.com/" target="_blank" rel="noreferrer" style={{ display: "block", color: "#0D5CAB", fontSize: "13px", padding: "8px", textDecoration: "none" }}>Portal Corporativo</a>
                  <a href="https://infra.pbi.dn-online.com/" target="_blank" rel="noreferrer" style={{ display: "block", color: "#0D5CAB", fontSize: "13px", padding: "8px", textDecoration: "none" }}>Reporte Power BI</a>
                  <a href="https://infra.cost.dn-online.com/" target="_blank" rel="noreferrer" style={{ display: "block", color: "#0D5CAB", fontSize: "13px", padding: "8px", textDecoration: "none" }}>Costos infra</a>
                </div>}
                <button onClick={cerrarSesion} style={{ ...opcionFiltro, color: "#B00020" }}>Cerrar sesión</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* KPIs */}
      {/* RESUMEN RÁPIDO */}
 
<div
style={{
display: "flex",
gap: "15px",
marginBottom: "25px",
flexWrap: "wrap"
}}
>
  
        <Card
  titulo="Dispositivos"
  valor={devices.length}
/>
        <Card
  titulo="Compliant"
  valor={
    devices.filter(
      d => d.complianceState === "compliant"
    ).length
  }
/>
        <Card
  titulo="No Cumplen"
  valor={
    devices.filter(
      d => d.complianceState === "noncompliant"
    ).length
  }
/>
        <Card
titulo="Cifrado"
valor={
devices.filter(
device => device.isEncrypted === true
).length
}
/>
        <Card
  titulo="Sin Cifrado"
  valor={
    devices.filter(
      device => device.isEncrypted === false
    ).length
  }
/>
       <Card
  titulo="Windows 10"
  valor={
    devices.filter(
      d =>
        d.osVersion &&
        parseInt(d.osVersion.split(".")[2]) < 22000
    ).length
  }
/>
       <Card
  titulo="Windows 11"
  valor={
    devices.filter(
      d =>
        d.osVersion &&
        parseInt(d.osVersion.split(".")[2]) >= 22000
    ).length
  }
/>
      </div>

   <div
  style={{
    marginTop: "10px",
    marginBottom: "20px"
  }}
>
  <hr
    style={{
      border: "none",
      borderTop: "2px solid #D9D9D9",
      marginBottom: "8px"
    }}
  />

  <div
    style={{
      color: "#0D5CAB",
      fontSize: "14px",
      fontWeight: "bold",
      paddingLeft: "5px"
    }}
  >
    Departamentos
  </div>
</div>

<div
  style={{
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "30px"
  }}
>
  {Object.keys(departamentos)
    .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }))
    .map((nombre) => (
     <Card
  key={nombre}
  titulo={
    nombre.replace("_", " ")
  }
  valor={departamentosFiltrados[nombre] || 0}
  onClick={() => aplicarFiltro("Category", nombre)}
/>
    ))}
</div>

      {/* BUSCADOR */}
          <div style={{ position: "relative" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px", // espacio entre textbox y botón
          marginBottom: "20px"
        }}
      >
       <input
  type="text"
  placeholder="Buscar PC, usuario o correo..."
  value={textoBusqueda}
  onChange={(e) => setTextoBusqueda(e.target.value.trim())}
  style={{
    width: "450px",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc"
  }}
/>

        <button
          onClick={() => {
setMostrarFiltros(!mostrarFiltros);
}}
          style={{
            backgroundColor: "#0D5CAB",
            color: "white",
            border: "none",
            padding: "12px 20px",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          FILTRAR ▼
        </button>
        <button
          onClick={() => setMostrarDuplicidad(!mostrarDuplicidad)}
          style={{
            backgroundColor: mostrarDuplicidad ? "#0D5CAB" : "#6C757D",
            color: "white",
            border: "none",
            padding: "12px 20px",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          DUPLICIDAD
        </button>
        {puedeCrearTickets && (
        <div style={{ position: "relative" }}>
          <button
            onClick={() => setMostrarMenuTickets(!mostrarMenuTickets)}
            style={{
              backgroundColor: "#8E44AD",
              color: "white",
              border: "none",
              padding: "12px 20px",
              borderRadius: "8px",
              cursor: "pointer"
            }}
          >
            CREAR TICKET ▼
          </button>
          {mostrarMenuTickets && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                left: 0,
                width: "220px",
                padding: "8px",
                backgroundColor: "white",
                borderRadius: "8px",
                boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                zIndex: 1100
              }}
            >
              {opcionesTicket.map((opcion) => (
                <button
                  key={opcion.key}
                  onClick={() => prepararTicket(opcion.key)}
                  style={opcionFiltro}
                >
                  {opcion.label}
                </button>
              ))}
            </div>
          )}
        </div>
        )}
<button
onClick={generarCSV}
style={{
backgroundColor: "#28A745",
color: "white",
border: "none",
padding: "12px 20px",
borderRadius: "8px",
cursor: "pointer",
marginLeft: "10px"
}}
>
📄 GENERAR CSV
</button>
        {Object.entries(filtrosAplicados).map(([tipo, valor]) => (
          <span
            key={tipo}
            style={{
              marginLeft: "15px",
              padding: "10px 15px",
              borderRadius: "20px",
              border: "1px solid #0D5CAB",
              backgroundColor: "#EAF2FF",
              fontWeight: "600"
            }}
          >
           
            {tipo}: {valor}
            <button
              onClick={() => limpiarFiltro(tipo)}
              style={{
                marginLeft: "10px",
                border: "none",
                background: "none",
                cursor: "pointer"
              }}
            >
              ✕
            </button>
          </span>
        ))}
      </div>

      {mostrarFiltros && (
        <div
          style={{
            display: "flex",
            gap: "20px",
            position: "absolute",
            top: "54px",
            left: "465px",
            width: "max-content",
            maxWidth: "calc(100vw - 40px)",
            marginTop: "8px",
            padding: "10px",
            zIndex: 1000,
            backgroundColor: "#F4F6F9",
            borderRadius: "10px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.2)"
          }}
        >
          <div
            style={{
              width: "150px",
              backgroundColor: "white",
              borderRadius: "10px",
              overflow: "15px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
            }}
          >
            <div style={itemFiltro}onClick={() => setFiltroSeleccionado("Compliance")}>🔰 Compliant</div>
            <div style={itemFiltro}onClick={() => setFiltroSeleccionado("Version")}>⚙ OS Version</div>
            <div style={itemFiltro}onClick={() => setFiltroSeleccionado("Encrypted")}>🔐 Encrypted</div>
            <div style={itemFiltro}onClick={() => setFiltroSeleccionado("Category")}>🌍 Departamento</div>
            <div style={itemFiltro}onClick={() => setFiltroSeleccionado("Join Type")}>🔗 Join Type</div>
          </div>

          {filtroSeleccionado === "Compliance" && (
  <div
    style={{
      width: "180px",
      backgroundColor: "white",
      borderRadius: "5px",
      padding: "5px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
    }}
  >
    <button
      style={opcionFiltro}
      onClick={() => aplicarFiltro("Compliance","Compliant")}
    >
      ✅ Compliant
    </button>

    <button
      style={opcionFiltro}
      onClick={() => aplicarFiltro("Compliance","Noncompliant")}
    >
      ❌ Noncompliant
    </button>
  </div>
)}


{filtroSeleccionado === "Version" && (
  <div
    style={{
      width: "180px",
      backgroundColor: "white",
      borderRadius: "5px",
      padding: "5px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
    }}
  >
    {versionesWindows.map((version) => (
      <button key={version} style={opcionFiltro} onClick={() => aplicarFiltro("Version", version)}>
        ⚙ {version}
      </button>
    ))}
  </div>
)}


{filtroSeleccionado === "Encrypted" && (
  <div
    style={{
      width: "180px",
      backgroundColor: "white",
      borderRadius: "5px",
      padding: "5px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
    }}
  >
    <button
      style={opcionFiltro}
      onClick={() => aplicarFiltro("Encrypted","Yes")}
    >
      ✅ Yes
    </button>

    <button
      style={opcionFiltro}
      onClick={() => aplicarFiltro("Encrypted","No")}
    >
      ❌ No
    </button>
    
      </div>
)}

{filtroSeleccionado === "Category" && (
  <div
    style={{
      width: "150px",
      backgroundColor: "white",
      borderRadius: "5px",
      padding: "5px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
    }}
  >
    {Object.keys(departamentos)
      .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }))
      .map((departamento) => (
      <button key={departamento} style={opcionFiltro} onClick={() => aplicarFiltro("Category", departamento)}>
        📁 {departamento.replace("_", " ")}
      </button>
    ))}
  </div>
)}

{filtroSeleccionado === "Join Type" && (
  <div
    style={{
      width: "180px",
      backgroundColor: "white",
      borderRadius: "5px",
      padding: "5px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
    }}
  >
    <button style={opcionFiltro}>
      🔗 Join Type
    </button>
  </div>
)}
      </div>
      )}
      </div>
       
      {devices.length > 0 && (
        <div
          style={{
            marginTop: "15px",
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.15)"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "15px", marginBottom: "20px", flexWrap: "wrap" }}>
            <h3 style={{ color: "#0D5CAB", margin: 0 }}>
              RESULTADOS ({devicesFiltrados.length} dispositivos)
            </h3>
            {devicesFiltrados.length > 0 && (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ color: "#536273", fontWeight: "600", fontSize: "13px" }}>
                  Página {Math.min(paginaActual, totalPaginas)} de {totalPaginas}
                </span>
                <button onClick={() => setPaginaActual((pagina) => Math.max(1, pagina - 1))} disabled={paginaActual === 1} style={{ ...opcionFiltro, width: "auto", padding: "8px 12px", backgroundColor: paginaActual === 1 ? "#B8C2CC" : "#0D5CAB", color: "white" }}>
                  Anterior
                </button>
                <button onClick={() => setPaginaActual((pagina) => Math.min(totalPaginas, pagina + 1))} disabled={paginaActual >= totalPaginas} style={{ ...opcionFiltro, width: "auto", padding: "8px 12px", backgroundColor: paginaActual >= totalPaginas ? "#B8C2CC" : "#0D5CAB", color: "white" }}>
                  Siguiente
                </button>
              </div>
            )}
          </div>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "auto"
            }}
          >
            <thead>
              <tr>
                <th style={th}>Usuario</th>
                <th style={th}>Correo</th>
                <th style={th}>Equipo</th>
                <th style={th}>Pais</th>
                <th style={th}>OS</th>
                <th style={th}>Compliance</th>
                <th style={{ ...th, whiteSpace: "nowrap" }}>Ownership</th>
                <th style={th}>Versión</th>
                <th style={th}>Cifrado</th>
                <th style={th}>Join type</th>
              </tr>
            </thead>
            <tbody>
  {devicesPagina.map((device, index) => (
    <tr key={index}>
      <td style={td}>
        {device.userDisplayName || "-"}
      </td>

      <td style={td}>
        {device.userPrincipalName || "-"}
      </td>

      <td style={td}>
        {device.deviceName || "-"}
      </td>
  <td style={td}>
  {obtenerDepartamento(device)}
</td>
      <td style={td}>
        {device.operatingSystem || "-"}
      </td>

      <td style={td}>
        {device.complianceState || "-"}
      </td>
      <td style={td}>
        {obtenerOwnership(device)}
      </td>
<td style={td}>
{obtenerVersionWindows(device.osVersion)}
</td>
<td style={td}>
{device.isEncrypted ? "✅ Sí" : "❌ No"}
</td>
<td style={td}>
{device.isJointype || "-"}
</td>
    </tr>
  ))}
</tbody>
          </table>
        </div>
      )}

      {mostrarVistaTicket && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "20px"
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "25px",
              width: "min(900px, 100%)",
              maxHeight: "85vh",
              overflow: "auto"
            }}
          >
            <h2 style={{ color: "#0D5CAB", marginTop: 0 }}>Vista previa del ticket</h2>
            <p>
              Se enviará a <strong>soportetecnico@dichter-neira.com</strong> desde
              <strong> jromero@dichter-neira.com</strong>.
            </p>
            <p>
              <strong>Inconsistencia:</strong>{" "}
              {opcionesTicket.find((item) => item.key === tipoTicket)?.label}
            </p>
            <p>
              <strong>Cantidad:</strong> {obtenerEquiposTicket(tipoTicket).length}
            </p>
            <label style={{ display: "block", fontWeight: "600", marginTop: "15px" }}>CC</label>
            <input value={ccTicket} onChange={(event) => setCcTicket(event.target.value)} placeholder="correo1@empresa.com; correo2@empresa.com" style={{ width: "100%", boxSizing: "border-box", padding: "10px", marginTop: "6px", border: "1px solid #ccc", borderRadius: "6px" }} />
            <small style={{ color: "#687684" }}>Separa varios correos con punto y coma (;).</small>
            <p>El cuerpo del correo incluirá el listado completo de equipos seleccionados.</p>
            {mensajeTicket && (
              <p style={{ color: mensajeTicket.startsWith("Error") ? "#B00020" : "#16803C" }}>
                {mensajeTicket}
              </p>
            )}
            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
              <button
                onClick={() => { setMostrarVistaTicket(false); setCcTicket(""); }}
                style={{ ...opcionFiltro, width: "auto", backgroundColor: "#6C757D", color: "white" }}
              >
                Cancelar
              </button>
              <button
                onClick={enviarTicket}
                disabled={enviandoTicket}
                style={{ ...opcionFiltro, width: "auto", backgroundColor: "#8E44AD", color: "white" }}
              >
                {enviandoTicket ? "Enviando..." : "Confirmar y enviar"}
              </button>
            </div>
          </div>
        </div>
        )}
    </div>
  );
}

function Card({ titulo, valor, onClick }) {
  return (
    <div
      style={{
        backgroundColor: "white",
        width: "180px",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
        textAlign: "center",
        cursor: onClick ? "pointer" : "default"
      }}
      onClick={onClick}
    >
      <h2
        style={{
          color: "#0D5CAB",
          margin: 0
        }}
      >
        {valor}
      </h2>
      <p>{titulo}</p>
    </div>
  );
}

const itemFiltro = {
  padding: "14px",
  borderBottom: "1px solid #EEEEEE",
  cursor: "pointer"
};

const opcionFiltro = {
  width: "80%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "8px",
  border: "1px solid #E0E0E0",
  backgroundColor: "white",
  textAlign: "left",
  cursor: "flex"
};

const th = {
  whiteSpace: "nowrap",
  backgroundColor: "#0D5CAB",
  color: "white",
  padding: "5px",
  textAlign: "left"
};

const td = {
  whiteSpace: "nowrap",
  padding: "5px",
  borderBottom: "1px solid #EEEEEE"
};

export default App;
